import React, {Component} from 'react';
import {Form, Modal, Button,message,Input,Select} from 'antd';	
import { connect } from 'react-redux';
import moment from 'moment';

import API from '@/API/api';
import {deleteCategoryLabelAPI,getCategoryLabelListAPI} from '@/API';
const FormItem = Form.Item;
const Option = Select.Option;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

class DeleteLabelModal extends Component{
	
	static contextTypes={
	    router: React.PropTypes.object.isRequired,
	}
	constructor(props) {
	    super(props);
	    this.state={
			btnLoading:false,
			categoryLabelList:[]
		}

    }
	componentDidMount(){
		this.getCategoryLabelList()
	}
	componentWillReceiveProps(nextProps){
		if(nextProps.openDelete==true){
			this.getCategoryLabelList()
		}
	}
	getCategoryLabelList(){
		let params={
			page:1,
			pagesize:500,
			type:7
		}
		getCategoryLabelListAPI(params).then(res=>{
			this.setState({categoryLabelList:res.data.list})
		})
	}
	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
	        this.setState({btnLoading:true})
	        let postForm={
	        		"cateitem_ids":values.labelIds,
	        		 "cate_type":'1'
	        }
			deleteCategoryLabelAPI(postForm).then(res=>{
				message.success('删除成功！');
		      	this.setState({btnLoading:false})
		      	this.props.handleClose()
		      	this.props.form.resetFields();
			}).catch(e=>{
				this.setState({btnLoading:false})
			})
           
	      }
	    });
	 }
	

	
	render(){
		let {btnLoading,categoryLabelList}=this.state
		let {openDelete,handleClose}=this.props
		const { getFieldDecorator } = this.props.form;
		const filedOption={
			select:{rules: [{ type: 'array',required: true, message: '必填项!', whitespace: true }]}
		}
		const categoryLabelOptions=categoryLabelList.map(d => <Option key={d.cateitem_id}>{d.cateitem}</Option>);
		return(
			<Modal
	          title="删除标签"
	          visible={openDelete}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>删除</Button>,
	          ]}
	        >
				<Form >
					<FormItem {...formItemLayout} label="标签名" hasFeedback>
						{getFieldDecorator(`labelIds`, filedOption.select)(
							<Select
						        showSearch
						        showArrow={false}
						        mode="multiple"
						        filterOption={(inputValue, option)=>{
						        		if(option.props.children.indexOf(inputValue)==0){
						        			return true
						        		}else{
						        			return false
						        		}
						        }}
						        notFoundContent={null}
						      >
						        {categoryLabelOptions}
						      </Select>
						)}
					</FormItem>
				</Form >
			 </Modal>
		)
	}
}


export const WrappedDeleteLabelModalForm = Form.create()(DeleteLabelModal)



// WEBPACK FOOTER //
// ./src/entry_app/knowledge_assist/wordBank/modal/delete_label.js